import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import '../Assistant/Assistant.css';
// import './PhoneNumber.css'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Modal from '@mui/material/Modal';
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from '@mui/material/FormHelperText';

import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';


const label = { inputProps: { 'aria-label': 'Switch demo' } };

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const drawerWidth = 300;
const Train = () => {
    const notify = () => toast.success('Setup Completed');
    const remove = () => toast.success('Deleted successfully');
  
    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
  
    const [pop, setPop] = useState(false);
    const handlePopOpen = () => setPop(true);
    const handlePopClose = () => setPop(false);
    // tab
      const [tab, setTab] = useState(0);
      const handleTabChange = (event, newValue) => {
        setTab(newValue);
      };
  
    const navigate = useNavigate();
  return (
    <div className="Train">
    <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
      <SideBar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: isLgUp ? 5 : 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          marginTop: isLgUp ? "0px" : "80px",
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}className="mb-20">
            <div className="PhoneNumber-main">
              <div className="display-2 heading-line">
              <h3>Assistant Name</h3>
              <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
                      <div className="bg-clr mt-10">
                        <Button startIcon={<PermPhoneMsgIcon/>}>Test Your Assistant</Button>
                      </div>
                      <div className="bg-clr mt-10">
                        <Button startIcon={<BookmarkAddedIcon/>}>SAVE</Button>
                      </div>
                    </Stack>
              </div>
            </div>
          </Grid2>
          <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mb-20">
          <div className="">
                <div className="tab-common">
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={tab}
                      onChange={handleTabChange}
                      aria-label="basic tabs example"
                    >
                      <Tab icon={<RecordVoiceOverIcon />} iconPosition="start" label="Item One" {...a11yProps(0)} />
                      <Tab label="Item Two" {...a11yProps(1)} />
                      <Tab label="Item Three" {...a11yProps(2)} />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={tab} index={0}>
                    Item One
                  </CustomTabPanel>
                  <CustomTabPanel value={tab} index={1}>
                    Item Two
                  </CustomTabPanel>
                  <CustomTabPanel value={tab} index={2}>
                    Item Three
                  </CustomTabPanel>
                </div>
              </div>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  </div>
  )
}

export default Train